import ActivityDzikir from './ActivityDzikir';

export default ActivityDzikir;
